import { Divider, IconButton } from '@material-ui/core';
import React, { useState, ChangeEvent } from 'react';
import styled from 'styled-components';
import Utils from '../../../Utils';

const Container = styled.div`
    width:100%
    padding-left:10px;
    display:grid;
    grid-template-columns:600px 100px;
    align-items:center;
    padding-top:5px;
    
`;

const TextFieldLabel = styled.div`
font-family: Roboto;
font-size: 14px;
font-weight: 400;
`

const TextFieldNameLabel = styled.div`
font-family: Roboto;
font-size: 14px;
font-weight: 600;
`

const ActionCommentHistroryV2 = ({procedureComment,index}) => {
    return (
        <>
        <Container  key={index}>
            <TextFieldNameLabel>
                {procedureComment.addedByName + ' :'} 

                <TextFieldLabel>
                    {procedureComment.comment}
                </TextFieldLabel>
            </TextFieldNameLabel>

            <TextFieldLabel>
                {Utils.formatDate(procedureComment.dateAdded)}
            </TextFieldLabel>

        </Container>
        <div style={{paddingTop:1}}/>
        </>                   
    )
}

export default ActionCommentHistroryV2;